import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
import Items from "../Items.js";

export default class CodeController {

  constructor(app) {
    this.app = app;
    this.items = app.items;
    this.PageId = "Code";
  }
  show(path, model) {
    this.populate();

    const swapPage = new SwapPage();
    swapPage.swapPage(this.PageId);
  }
  populate() {
    let model = {promoCode:''};

    const dataBinder = new DataBinder();
    dataBinder.populate(this.PageId, model);
  }
   notification(msg) {
    this.app.showToast(msg);
  }
  applyPromoCode(code) {
    if (!code) return;

    const app = this.app;

    if (!code) return;
    let promoItem = app.items.applyPromoCode(code, app.userdata);

    if (promoItem && promoItem.error) {
      app.showToast(promoItem.message, 3);
      return;
    }
    if (promoItem === null) {
      app.showToast("Invalid Promo Code", 3);
      return;
    }
    let message = "You have redeemed: " + promoItem.description;
    const item = promoItem.item;
    app.showToast(message);
    if (item) app.showNewItemPopup(item);
    app.save(true);
    app.populate();
  }
  
}